import type { Module } from 'vuex';
import { CurrencyBlockchain } from '@/types/CurrencyBlockchain';
import {RootState} from "@/store";

export interface CurrencyBlockchainsState {
  currencyBlockchains: CurrencyBlockchain[];
}

const currencyBlockchainsModule: Module<CurrencyBlockchainsState, RootState> = {
  namespaced: true,
  state: (): CurrencyBlockchainsState => ({
    currencyBlockchains: [],
  }),
  mutations: {
    setCurrencyBlockchains(state, payload: { currencyBlockchains: Record<string, any> }) {
      state.currencyBlockchains = [];
      Object.keys(payload.currencyBlockchains).forEach(countryId => {
        Object.keys(payload.currencyBlockchains[countryId]).forEach(blockchainId => {
          const raw = payload.currencyBlockchains[countryId][blockchainId];
          state.currencyBlockchains.push(CurrencyBlockchain.fromRaw(raw));
        });
      });
    },
    setCurrencyBlockchainsCreate(state, payload: any) {
      state.currencyBlockchains.push(CurrencyBlockchain.fromRaw(payload));
    },
    setCurrencyBlockchainsUpdate(state, payload: any) {
      const idx = state.currencyBlockchains.findIndex(
        cb => cb.idCurrency === Number(payload.idCurrency) && cb.idBlockchain === Number(payload.idBlockchain)
      );
      if (idx !== -1) {
        state.currencyBlockchains[idx] = { ...state.currencyBlockchains[idx], ...payload };
      }
    },
    setCurrencyBlockchainsDelete(state, payload: { idCurrency: number; idBlockchain: number }) {
      state.currencyBlockchains = state.currencyBlockchains.filter(
        cb => !(cb.idCurrency === Number(payload.idCurrency) && cb.idBlockchain === Number(payload.idBlockchain))
      );
    },
    setCurrencyBlockchainsLock(state, payload: { idCurrency: number; idBlockchain: number }) {
      const cb = state.currencyBlockchains.find(
        cb => cb.idCurrency === Number(payload.idCurrency) && cb.idBlockchain === Number(payload.idBlockchain)
      );
      if (cb) cb.locked = true;
    },
    setCurrencyBlockchainsUnlock(state, payload: { idCurrency: number; idBlockchain: number }) {
      const cb = state.currencyBlockchains.find(
        cb => cb.idCurrency === Number(payload.idCurrency) && cb.idBlockchain === Number(payload.idBlockchain)
      );
      if (cb) cb.locked = false;
    },
  },
  actions: {
    wsCurrencyBlockchains({ commit }, payload) {
      commit('setCurrencyBlockchains', payload);
    },
    wsCurrencyBlockchainsCreate({ commit }, payload) {
      commit('setCurrencyBlockchainsCreate', payload);
    },
    wsCurrencyBlockchainsUpdate({ commit }, payload) {
      commit('setCurrencyBlockchainsUpdate', payload);
    },
    wsCurrencyBlockchainsDelete({ commit }, payload) {
      commit('setCurrencyBlockchainsDelete', payload);
    },
    wsCurrencyBlockchainsLock({ commit }, payload) {
      commit('setCurrencyBlockchainsLock', payload);
    },
    wsCurrencyBlockchainsUnlock({ commit }, payload) {
      commit('setCurrencyBlockchainsUnlock', payload);
    },
  },
};

export default currencyBlockchainsModule;
